import { createFileRoute } from '@tanstack/react-router'

import { CourseGenericLecturePage } from '@/course-generic/components/CourseGenericLecturePage/CourseGenericLecturePage'

export const Route = createFileRoute(
  '/_learning/course-generic/$course/$topic/$lecture/{-$suffix}/{-$id}',
)({
  component: CourseGenericLecturePage,
})
